import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, first, tap, throwError } from 'rxjs';

import { AuthService } from '../auth.service';

type VerificationState = 'loading' | 'success' | 'error';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
})
export class VerifyEmailComponent implements OnInit {
  public state: VerificationState = 'loading';
  public errorMessage: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.state = 'error';
      this.errorMessage = 'Invalid verification link. No token provided.';
      return;
    }

    this.verifyEmail(token);
  }

  private verifyEmail(token: string): void {
    this.authService.verifyEmail(token)
      .pipe(
        catchError(error => {
          this.state = 'error';
          if (error.status === 400) {
            this.errorMessage = 'Invalid or expired verification link.';
          } else if (error.status === 404) {
            this.errorMessage = 'Verification token not found.';
          } else {
            this.errorMessage = error.error?.message || 'Verification failed. Please try again.';
          }
          return throwError(() => error);
        }),
        first(),
        tap(() => {
          this.state = 'success';
        })
      )
      .subscribe();
  }

  public goToApplications(): void {
    this.router.navigate(['/candidate/applications']);
  }

  public goToLogin(): void {
    this.router.navigate(['/candidate-login']);
  }
}
